import { programTypeMapper } from "@tailormed/common-client/util/programTypeMapping";

// programSubtypes arrives as a JSON string on table rows (cf. PendingRenewalTable) — parse before classifying.
export const parseProgramSubtypes = (programSubtypes) => {
  if (typeof programSubtypes !== "string") return programSubtypes;
  try {
    return JSON.parse(programSubtypes);
  } catch (e) {
    return [];
  }
};

// Track-tab parity: Max Benefit is required to approve, except for free-drug programs.
export const isMaxBenefitRequiredForRecord = (record) =>
  !programTypeMapper?.isManufacturerFreeDrugProgram({
    ...record,
    programSubtypes: parseProgramSubtypes(record.programSubtypes)
  });
